import { render } from "./my-service.vue?vue&type=template&id=ae2a622c"
import script from "./my-service.vue?vue&type=script&lang=js"
export * from "./my-service.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__